export const WhatstsAppId = '+8613417751241';

export const CurrencyEnum = {
  USD: '$',
  CNY: '￥',
  SAR: 'SAR',
  RUB: '₽',
};

export const commodityCountry = ['RU'];
